export default __webpack_public_path__ + "static/media/back-icon.aaf5867e.svg";